<template>
    <div class="flex-grow-1">
        <div class="d-flex align-items-center">
            <div class="mr-3">
                <tippy placement="left" arrow interactive :delay="[500, 0]">
                    <template v-slot:trigger>
                        <b-img
                            :src="asset.url"
                            class="p-0"
                            width="100"
                            height="auto"
                            thumbnail
                        />
                    </template>
                </tippy>
            </div>
            <div class="d-flex align-items-center flex-column mr-3">
                <div>
                    <div v-if="asset.id" class="d-flex">
                        <div class="label mr-1">
                            Media ID:
                        </div>
                        <div>
                            <strong>{{asset.id}}</strong>
                        </div>
                    </div>
                    <div v-if="asset.title" class="d-flex">
                        <div class="label mr-1">
                            Title:
                        </div>
                        <div>
                            <strong>{{asset.title}}</strong>
                        </div>
                    </div>
                    <!-- <div v-if="asset.objectname" class="d-flex">
                        <div class="label mr-1">
                            Object:
                        </div>
                        <div>
                            <strong>{{asset.objectname}}</strong>
                        </div>
                    </div> -->
                    <div v-if="asset.caption" class="d-flex">
                        <div class="label mr-1">
                            Caption:
                        </div>
                        <div>
                            <strong>{{asset.caption}}</strong>
                        </div>
                    </div>
                    <div v-if="asset.credit" class="d-flex">
                        <div class="label mr-1">
                            credit:
                        </div>
                        <div>
                            <strong>{{asset.credit}}</strong>
                        </div>
                    </div>
                    <div v-if="asset.description" class="d-flex">
                        <div class="label mr-1">
                            Desc:
                        </div>
                        <div>
                            <strong>{{asset.description}}</strong>
                        </div>
                    </div>

                    <!-- <div  class="d-flex align-items-center mb-1">
                        <div class="label mr-1">
                            Size:
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" id="merlin-small" value="small" v-model="imageSize">
                            <label class="form-check-label" for="merlin-small">Small</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" id="merlin-med" value="medium" v-model="imageSize">
                            <label class="form-check-label" for="merlin-med">Medium</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" id="merlin-full" value="full" v-model="imageSize">
                            <label class="form-check-label" for="merlin-full">Full size</label>
                        </div>
                    </div> -->
                    <div class="d-flex align-items-center mb-1">
                        <div class="label mr-1">
                            Width:
                        </div>
                        <div>
                            <b-input-group size="sm">
                                <b-form-input type="number" v-model="width" style="width: 100px;" min="1" max="100" @keydown.enter.prevent />
                                <b-input-group-append is-text>
                                    %
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="label mr-1">
                            Align:
                        </div>
                        <div>
                            <b-form-select size="sm" v-model="position" style="width: 100px;" @keydown.enter.prevent>
                                <b-form-select-option value="left">
                                    Left
                                </b-form-select-option>
                                <b-form-select-option value="right">
                                    Right
                                </b-form-select-option>
                            </b-form-select>
                        </div>
                    </div>
                    <div v-if="asset.keywords || asset.specialinstructions || asset.captionwriter">
                        <b-link
                            href="#"
                            @click="more_visible = !more_visible"
                        >
                            More
                            <span
                                class="collapse-icon mr-2"
                                :class="{'collapsed': !more_visible}"
                                :aria-expanded="more_visible ? 'true' : 'false'"
                            >
                                <span class="open">
                                    <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                                </span>
                                <span class="closed">
                                    <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                                </span>
                            </span>
                        </b-link>
                        <b-collapse v-model="more_visible" class="mt-1">
                            <div v-if="asset.keywords" class="d-flex">
                                <div class="label mr-1">
                                    <div>
                                        Keywords:
                                    </div>
                                    <div></div>
                                </div>
                                <div>
                                    <strong>{{asset.keywords}}</strong>
                                </div>
                            </div>
                            <div v-if="asset.captionwriter" class="d-flex">
                                <div class="label mr-1">
                                    <div>
                                        Writer Caption:
                                    </div>
                                    <div></div>
                                </div>
                                <div>
                                    <strong>{{asset.captionwriter}}</strong>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </div>
            </div>
            <div class="ml-auto">
                <div class="text-nowrap">
                    <span v-if="assetLinked(asset)">
                        <b-link class="text-warning" href="#" @click.prevent="unlinkAsset(asset)">
                            <font-awesome-icon :icon="['fad', 'unlink']" />
                        </b-link>
                    </span>
                    <span v-else>
                        <span v-if="asset.linking">
                            <b-spinner small label="Loading..."></b-spinner>
                        </span>
                        <span v-else>
                            <b-link class="text-primary" href="#" @click.prevent="linkAsset(asset)">
                                <span v-if="related_media">
                                    <font-awesome-icon :icon="['fad', 'link']" />
                                </span>
                                <span v-else>
                                    <font-awesome-icon :icon="['fad', 'plus-square']" />
                                </span>
                            </b-link>
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.label {
    min-width: 77px;
}

.copy-to-clipboard {
    display: none;
}

.merlin-id:hover {
    .copy-to-clipboard {
        display: inline-block;
    }
}
</style>

<script>
import copy from 'copy-html-to-clipboard'

import { mapState } from 'vuex'

export default {
    data: () => ({
        width: null,
        position: null,
        imageSize: 'medium',

        more_visible: false
    }),
    computed: {
        ...mapState({

        })
    },
    props: [
        'publication',
        'asset',
        'related_media',
        'file_extensions',
        'type'
    ],
    components: {},
    methods: {
        linkAsset (asset) {
            this.$emit('link', asset, this.width, this.position, this.imageSize)
        },
        unlinkAsset (asset) {
            this.$emit('unlink', asset)
        },
        assetLinked (asset) {
            let assetLinked = false

            if (
                this.related_media &&
                this.related_media.length
            ) {
                _.forEach(this.related_media, item => {
                    if (
                        item.dam_id == asset.merlinid &&
                        (item.pivot && item.pivot.publication_id == this.publication.id)
                    ) {
                        assetLinked = true
                    }
                })
            }

            return assetLinked
        },
        copyToClipboard (value) {
            copy(value, {
                asHtml: false
            })
        }
    }
}
</script>
